import { loadableWithFallback } from '@vision/ui/utils';
import type { TableChartAtaCombinedProps } from './TableChartAtaCombined';

export const TableChartAtaCombined = loadableWithFallback<TableChartAtaCombinedProps>(
  () => import('./TableChartAtaCombined'),
);
